import { Time, type ZonedDateTime } from "@internationalized/date";
import { useTranslations } from "next-intl";
import { type Dispatch, type SetStateAction } from "react";
import { useDateFormatter } from "react-aria";

import { Large } from "~/components/typography";
import { RadioGroup, RadioGroupItem } from "~/components/ui/radio-group";

export function BookMeetingTimePicker({
  setValue,
  timeSlots,
  value,
}: {
  setValue: Dispatch<SetStateAction<Time>>;
  timeSlots: Time[];
  value: ZonedDateTime;
}) {
  const t = useTranslations("BookMeeting");
  const formatTime = useDateFormatter({ timeStyle: "short" });
  return (
    <div>
      <Large className="mb-4 mt-2 block text-center">{t("time")}</Large>
      <RadioGroup
        className="grid-cols-2 text-sm md:grid-cols-3"
        onValueChange={(value) => {
          setValue(
            timeSlots.find((timeSlot) => timeSlot.toString() === value)!,
          );
        }}
        defaultValue={new Time(value.hour, value.minute).toString()}
      >
        {timeSlots.map((timeSlot) => (
          <RadioGroupItem key={timeSlot.toString()} value={timeSlot.toString()}>
            {formatTime.format(
              value
                .set({ hour: timeSlot.hour, minute: timeSlot.minute })
                .toDate(),
            )}
          </RadioGroupItem>
        ))}
      </RadioGroup>
    </div>
  );
}
